export default __webpack_public_path__ + "static/media/Eye_4_M_C6.2456b1ce.svg";